/* global femcare, jwplayer */

/**
 * Inline Video Functions
 * Handles inline video player initialization and controls
 */

/**
 * Initialize all inline videos
 */
femcare.video.initInlineVideos = function () {
    this.$inlineVideos.each((index, element) => {
        const $inlineVideo = $(element);
        const $videoPlayerWrapper = $inlineVideo.find('.video-player-parent');
        const playerId = `jwplayer-${Date.now()}-${index}`;

        const $videoPlayer = $('<div class="video-player"></div>');
        $videoPlayer.attr('id', playerId);
        $videoPlayerWrapper.append($videoPlayer);

        const videoConfig = this.buildVideoConfig($inlineVideo);

        $inlineVideo.on('click', '.video__poster', (e) => {
            e.preventDefault();

            femcare.shared.pubsub.publish('VIDEO_CLICK', {
                $trigger: $inlineVideo
            });

            this.pauseAllVideos();
            $videoPlayerWrapper.addClass('video-player-parent--show');

            this.checkJWPlayer().then(() => {
                const player = jwplayer(playerId).setup(videoConfig);
                this.setupVideoEvents(player, $inlineVideo, $videoPlayerWrapper, playerId);
                this.activePlayers.push(player);
                player.play();
            });
        });
    });
};

/**
 * Build video configuration from element attributes
 */
femcare.video.buildVideoConfig = function ($element) {
    const sources = [];
    const hlsUrl = $element.attr('data-video-url-hls');
    const progressiveUrl = $element.attr('data-video-url-progressive');

    if (hlsUrl) sources.push({ file: hlsUrl, type: 'hls' });
    if (progressiveUrl) sources.push({ file: progressiveUrl, type: 'mp4' });

    return {
        file: sources[0]?.file,
        sources: sources,
        image: $element.attr('data-video-image'),
        title: $element.attr('data-video-name'),
        aspectratio: $element.attr('data-video-aspect-ratio') || '16:9',
        width: '100%',
        height: 'auto',
        controls: $element.attr('data-video-controls') !== 'false',
        mute: $element.attr('data-video-mute') === 'true',
        autostart: false,
        autoPause: { viewability: true },
        repeat: $element.attr('data-video-repeat') === 'true',
        sharing: false,
        analytics: { enabled: true, cookies: false }
    };
};